import "babel-polyfill";
import { getClosest } from "./modules/polyfill";
import { Menu } from "./modules/menu";
import { ButtonDropdown } from "./modules/button-dropdown";
import { complexSlider, simpleSlider } from "./modules/slider";
import { Cookiebar } from "./modules/cookiebar";

document.addEventListener("DOMContentLoaded", () => {
    getClosest();
    new Cookiebar();
    new Menu();
    new ButtonDropdown();
    new complexSlider();
    new simpleSlider();
});
